export const ncciCategories = [
  { min: Number.NEGATIVE_INFINITY, max: 0.0, label: "Water/Soil", value: 1, color: "#fff5ec" },
  { min: 0.0, max: 0.2, label: "Very Low", value: 2, color: "#414487" },
  { min: 0.2, max: 0.4, label: "Low Nitrogen", value: 3, color: "#2A788E" },
  { min: 0.4, max: 0.6, label: "Moderate Nitrogen", value: 4, color: "#22A884" },
  { min: 0.6, max: 0.8, label: "High Nitrogen", value: 5, color: "#FDE725" },
  { min: 0.8, max: Number.POSITIVE_INFINITY, label: "Very High", value: 6, color: "#7AD151" }
];


export const ndreCategories = [
  { min: Number.NEGATIVE_INFINITY, max: 0.0, label: "Non-Vegetated", value: 1, color: "#fff5ec" },
  { min: 0.0, max: 0.15, label: "Bare Soil", value: 2, color: "#FFDAB9" },
  { min: 0.15, max: 0.30, label: "Sparse/Stressed", value: 3, color: "#e6e600" },
  { min: 0.30, max: 0.50, label: "Moderate healthy", value: 4, color: "#bfff00" },
  { min: 0.50, max: 0.65, label: "Healthy", value: 5, color: "#00d400" },
  { min: 0.65, max: Number.POSITIVE_INFINITY, label: "Mature", value: 6, color: "#00e6ac" }
];

export const ndviCategories = [
  { min: Number.NEGATIVE_INFINITY, max: 0.0, label: "Water", value: 1, color: "#FFDAB9" },
  { min: 0.0, max: 0.15, label: "Bare Soil", value: 2, color: "#E6E600" },
  { min: 0.15, max: 0.30, label: "Low Vegetation", value: 3, color: "#CEFF33" },
  { min: 0.30, max: 0.50, label: "Moderate Vegetation", value: 4, color: "#8DD874" },
  { min: 0.50, max: 0.65, label: "Healthy Vegetation", value: 5, color: "#00CC00" },
  { min: 0.65, max: Number.POSITIVE_INFINITY, label: "Dense Vegetation", value: 6, color: "#275216" }
];

export const ndmiCategories = [
  { label: "Bare Soil", value: 1, color: "#d7191c" },
  { label: "Dry Vegetation", value: 2, color: "#ffa52c" },
  { label: "Moderate Moisture", value: 3, color: "#d1ddeb" },
  { label: "Healthy Vegetation", value: 4, color: "#b9dda5" },
  { label: "High Moisture", value: 5, color: "#4c91e1" },
  { label: "Waterlogging", value: 6, color: "#2ded37" }
];

export const cwsiCategories = [
  { label: "Well-Watered", value: 1, color: "#c6f59b" },
  { label: "Low Stress", value: 2, color: "#30f565" },
  { label: "Mild Stress", value: 3, color: "#fefe00" },
  { label: "Moderate Stress", value: 4, color: "#f0dba1" },
  { label: "High Stress", value: 5, color: "#e5c25f" }
];

export const tvdiCategories = [
  { label: "Very Dry", value: 1, color: "#ffa52c" },
  { label: "Dry to Moderate", value: 2, color: "#f4f61c" },
  { label: "Moderate", value: 3, color: "#1dffee" },
  { label: "Moist to Wet", value: 4, color: "#0000ff" },
  { label: "Very Moist", value: 5, color: "#00ff26" },
  { label: "Saturated", value: 6, color: "#2f9339" }
];

export const ndtiCategories = [
  { label: "No fire", value: 1, color: "#020257" },
  { label: "Smoke", value: 2, color: "#e95211" },
  { label: "Fire", value: 3, color: "#eef44a" }
];

export const osiCategories = [
  { label: "Oil Sheen", value: 1, color: "#F48416" },
  { label: "Thick Slick", value: 2, color: "#F6EE5D" }
];

export const mbsiCategories = [
  { label: "Very Dense Vegetation", value: 1, color: "#236d2a" },
  { label: "Dense Vegetation", value: 2, color: "#099616" },
  { label: "Moderate Vegetation", value: 3, color: "#ffa52c" },
  { label: "Sparse Vegetation", value: 4, color: "#94d180" },
  { label: "Sparse Dry", value: 5, color: "#7f681a" },
  { label: "Bare Soil", value: 6, color: "#DCBE56" }
];


